
<DataPage
  ref="documentsDataPage"
  :fetch-callback="fetchDocuments"
  :model="DocumentModel"
  list
  :selectable="isSelectable"
  :row-selected="handleRowSelect"
>
  <template #pageHeader>
    <div>
      <EntityShowHeader :entity="entity" />
      <DocumentResourceNav :resource="'entities'" />
    </div>
  </template>

  <template #tableHeaderActions>
    <b-button
      v-can:entities.documents.upload
      variant="primary"
      size="sm"
      @click="openUploadModal"
    >
      <Icon icon="cloud-upload" size="14" class="mr-2" />
      {{ __('buttons.upload') }}
    </b-button>
    <b-button
      variant="outline-primary"
      size="sm"
      class="ml-2"
      @click="handleNewFolderClick"
    >
      <Icon class="mr-2" icon="folder" size="14" />
      {{ __('documents.button-new-folder') }}
    </b-button>
    <b-button
      v-if="hasSelectedRows"
      v-can:documents.update
      class="ml-2"
      variant="outline-warning"
      size="sm"
      @click="moveDocumentInBulk"
    >
      <Icon icon="arrow-right" class="mr-2" size="14" />
      {{ __('buttons.move') }}
    </b-button>
  </template>

  <template #iconBlock="{ item }">
    <img :src="getFileTypeIcon(item)" :alt="item.name" width="48" />
  </template>

  <template #label="{ item }">
    <RouterLink
      v-if="item.isFolder"
      v-can:entities.documents.view
      :to="{
        name: 'entities.documents.list.folder',
        params: { folderId: item.id },
      }"
    >
      {{ item.name }}
    </RouterLink>
    <a v-else href="#" @click.prevent="download(item.id)">
      {{ item.name }}
    </a>
  </template>

  <template #badge="{ item }">
    <Badge v-if="item.fileType" variant="soft-secondary" class="ml-3">
      {{ item.fileType }}
    </Badge>
  </template>

  <template #description="{ item }">
    <DocumentRowSummary v-if="item" :document="item" />
  </template>

  <template #actionButtons="{ item }">
    <Badge v-if="item.type" variant="soft-info" class="ml-3">
      {{ item.type.name }}
    </Badge>

    <ActionPopover
      v-if="item.isFolder"
      :id="item.id"
      v-can-any="['documents.update', 'documents.destroy']"
    >
      <b-button
        v-can:documents.update
        class="dropdown-item"
        size="sm"
        @click="handleEditFolderClick(item)"
      >
        <Icon icon="edit" class="mr-2" size="14" />
        {{ __('buttons.edit') }}
      </b-button>
      <b-button
        v-can:documents.destroy
        class="dropdown-item"
        size="sm"
        @click="removeFolder(item.id)"
      >
        <Icon icon="trash" class="mr-2" size="14" />
        {{ __('buttons.delete') }}
      </b-button>
    </ActionPopover>

    <ActionPopover
      v-else
      :id="item.id"
      v-can-any="[
        'entities.documents.download',
        'entities.documents.destroy',
      ]"
    >
      <b-button
        v-can:entities.documents.download
        class="dropdown-item"
        size="sm"
        @click="download(item.id)"
      >
        <Icon icon="cloud-download" class="mr-2" size="14" />
        {{ __('buttons.download') }}
      </b-button>

      <b-button
        v-can:entities.documents.destroy
        class="dropdown-item"
        size="sm"
        @click="remove(item.id)"
      >
        <Icon icon="trash" class="mr-2" size="14" />
        {{ __('buttons.delete') }}
      </b-button>

      <b-button
        v-can:documents.update
        class="dropdown-item"
        size="sm"
        @click="moveDocument(item)"
      >
        <Icon icon="arrow-right" class="mr-2" size="14" />
        {{ __('buttons.move') }}
      </b-button>
    </ActionPopover>
  </template>
</DataPage>
